import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootPrintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_footprint_generic_json_order_schemaService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { example?: boolean, map?: boolean }): Promise<{ DatexOrderInfo?: $frontendTypes.FootPrintApiManager.DatexOrderInfo, Addresses?: $frontendTypes.FootPrintApiManager.Address[], Shipments?: $frontendTypes.FootPrintApiManager.Shipment[], Conveyance?: $frontendTypes.FootPrintApiManager.Conveyance, ShipmentTotals?: $frontendTypes.FootPrintApiManager.ShipmentTotals, Orders?: $frontendTypes.FootPrintApiManager.Order[], OrderLines?: $frontendTypes.FootPrintApiManager.OrderLine[], DockAppointments?: $frontendTypes.FootPrintApiManager.DockAppointment[], UserDefinedFields?: $frontendTypes.FootPrintApiManager.UserDefinedField[], ReasonCodes?: $frontendTypes.FootPrintApiManager.ReasonCode[], Material?: $frontendTypes.FootPrintApiManager.Material, MaterialPackaging?: $frontendTypes.FootPrintApiManager.MaterialPackaging, Lot?: $frontendTypes.FootPrintApiManager.Lot, ShippingContainer?: $frontendTypes.FootPrintApiManager.ShippingContainer, LicensePlates?: $frontendTypes.FootPrintApiManager.LicensePlate[], LicensePlateContents?: $frontendTypes.FootPrintApiManager.LicensePlateContents[], SerialNumbers?: $frontendTypes.FootPrintApiManager.SerialNumber[], WavelengthConnectorTransmissions?: $frontendTypes.FootPrintApiManager.WavelengthConnectorTransmission[], PalletTransactions?: $frontendTypes.FootPrintApiManager.PalletTransaction[], AddressEntityTypes?: string[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

